import Vue from "vue";
import Vuetify from "vuetify";

import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
    theme: {
        dark: false,
        themes: {
            light: {
                blew: "#2690CB",
                dark: "#5C6275",
                burgundy: "#DF677F",
                fade: "#ECEFF5",
                darkFade: "#868EA4",
                redLight: "#EB5757",
                darkBlue: "#073554",
                darkBlue80: "#0B3E68",
                touchBlue: "#E8F5FA",
                touchRed: "#FFF0F2",
                disabled: "#B9BDC7",
                darkYellow: "#DDB230",
                backgroundYellow: "#FCEFCA",
                backgroundGreen: "#DDFAE6",
                darkGreen: "#219653",
                gray3: "#999999",
                green3: "#6FCF97",
                black60: "#5F6377",
                errorRed: "#FFD4D3",
                black: "#000",
                danger: "#df4f4f",
                lightgreen: "#e2f5ea",
                lightblue: "#e1f4fc",
                lightgreynew: "#afbaca",
                greynew: "#61748f",
                blacknew: "#3d3d3d",
                lightred: "#FFEBEE",
            },
        },
    },

    icons: {
        iconfont: "mdi", // default - only for display purposes
    },
};

export default new Vuetify(opts);



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js